import { ApiParameter, post, request } from "@insite/client-framework/Services/ApiService";

export interface AtDataModel {
    email?: string;
    first?: string;
    last?: string;
    street?: string;
    city?: string;
    zip?: string;
    phone?: string;
    ip?: string;
    userprofileid?: string;
    customerbilltoid?: string;
    customershiptoid?: string;
    isguest?: boolean;
}

const atDataUrl = "api/v2/atdataapi";

export async function addAtDataFields(parameter: AtDataModel) {
    try {
        const headers = {
            "Content-Type": "application/json", // Set the Content-Type header to JSON
        };
        const response = await request<AtDataModel>(atDataUrl, "POST", headers, JSON.stringify(parameter));
        return response;
    } catch (error) {
        console.log("Error adding AtDataFields:", error);
        throw new Error("Failed to add AtDataFields");
    }

}
